angular.module('unergie.main')
.controller('changePwdLandingCtrl', ($state, $scope, $stateParams, ReferencesService, BoFeaturesService, ApiUser, identity) => {
    $scope.errorMessage = undefined

    $scope.minStrength = 3

    $scope.identity = identity

    BoFeaturesService.getFeatures().then((features) => {
        const env = BoFeaturesService.getEnv()
        const envLabels = features.styles
        $scope.companyLogo = envLabels.companyLogo
        const envType = env && env.split('-').pop()
        $scope.envLabel = _.get(envLabels, [envType, 'label'], 'Development')
        $scope.envStyle = _.get(envLabels, [envType, 'style'], 'devel')
        $('#dynamic-favicon').attr('href', `/images/assets/img/${_.get(envLabels, `${envType}.favicon`, `favicon_int.png`)}`)
    })

    $scope.applyEnvClass = (className) => {
        if ($scope.envStyle) return `${className}--${$scope.envStyle}`
    }

    $scope.scoreMeaning = [
        'Trop simple',
        'Trop simple',
        'Encore un petit effort',
        'Acceptable',
        'Top !',
    ]

    $scope.pwdStrength = function () {
        if ($scope.password) {
            return zxcvbn($scope.password).score
        }
    }

    $scope.submitPassword = function () {
        $scope.modifyingPwd = true
        return ApiUser.changePwd({ id: $stateParams.token }, { password: $scope.password, passwordCheck: $scope.passwordCheck }).$promise
        .then((result) => {
            BoFeaturesService.refreshFeatures()
            $state.go('userInfo')
        })
        .catch((error) => {
            $scope.errorMessage = error.data.message
        })
        .finally(() => {
            $scope.modifyingPwd = false
        })
    }
})
